import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  name: 'ISBLANK',
  category: FunctionCategory.LOGIC,
  description: 'Checks whether each value of a column or a single value is empty or null.',
  shortDescription: 'Checks whether a value is empty or null',
  params: [
    {
      name: 'value',
      type: ArgType.any,
      description: 'Either a column or value.',
    },
  ],
} satisfies AnalysisFunction;
